import { useEffect, useState } from "react";
import reportServices from "app/services/automations/report-services";

// Tipos de reporte, locales y períodos sugeridos para plantillas, tal como los entrega el backend.
const useReportCatalog = () => {
    const [catalog, setCatalog] = useState({ types: [], stores: [], periods: [] });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        reportServices.getTypes()
            .then((resp) => setCatalog({ types: resp?.types || [], stores: resp?.stores || [], periods: resp?.periods || [] }))
            .catch(() => setError("No se pudieron cargar los reportes."))
            .finally(() => setLoading(false));
    }, []);

    return { ...catalog, loading, error };
};

export default useReportCatalog;
